<template>
    <div class="ag-status-name-value status-bar mb-5 mb-md-4">
        <div class="left-text description-text">
            Depending on Filter By selection, this report utilizes either invoice creation date or arrival date to determine which invoices are included in the report
        </div>
    </div>
</template>

<script>
    export default {
        name: 'totalStatusBar',
        data: function () {
            return {
                total: null,
            };
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';
    .status-bar {
        text-align: right !important;
    }
    .left-text {
        left: 2em;
        position: absolute;
    }
    .total-text{
        font-size: 0.9rem;
        vertical-align: center;
    }
    .description-text{
        white-space: initial;
    }
     @include media-breakpoint-down(md) {
        .left-text {
            left: 8px;
            position: absolute;
        }
        .description-text{
            font-size: 12px;
            line-height: 1.3;
            text-align: left;
        }
        .text-block {
            display: block;
        }
    }


</style>
